import { types, flow, getParent, applySnapshot } from "mobx-state-tree";
import { v4 } from "uuid";

import { Outlet, Product } from "./common";
import { URL_API } from "./globals";

const ItemProduct = types
  .model("ItemProduct", {
    id: types.identifier,
    product: types.reference(Product),
    count: types.optional(types.number, 0),
    isPresent: types.optional(types.boolean, true),
    balance: types.optional(types.number, 0),
    store: types.optional(types.number, 0),
    possibility: types.optional(types.number, 0),
    defect: types.optional(types.number, 0),
  })
  .actions((self) => ({
    set(row) {
      applySnapshot(self, row);
    },
  }));

const ItemAction = types.model("ItemAction", {
  id: types.identifier,
  product: types.reference(Product),
  date: types.optional(types.string, ""),
  deliverydate: types.optional(types.string, ""),
});

const Visit = types
  .model("Route", {
    id: types.identifier,
    outlet: types.reference(Outlet),
    products: types.optional(types.array(ItemProduct), []),
    actions: types.optional(types.array(ItemAction), []),
    start_time: types.optional(types.number, 0),
    end_time: types.optional(types.number, 0),
    start_latitude: types.optional(types.number, 0),
    end_latitude: types.optional(types.number, 0),
    start_longitude: types.optional(types.number, 0),
    end_longitude: types.optional(types.number, 0),
  })
  .actions((self) => ({
    setVisit: flow(function* () {
      const response = yield fetch(`${URL_API}/api/setvisit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: self }),
      });
      const json = yield response.json();
    }),
  }));

const Route = types
  .model("Route", {
    date: types.string,
    visits: types.optional(types.array(Visit), []),
    currentvisit: types.optional(types.maybeNull(types.reference(Visit)), null),
    amount_hours: types.optional(types.number, 0),
    amount_outlets: types.optional(types.number, 0),
    comment: types.optional(types.string, ""),
  })
  .actions((self) => ({
    setAmount_Hours: flow(function* (merch, amount_hours) {
      self.amount_hours = Number(amount_hours);
      const response = yield fetch(`${URL_API}/api/settrip`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: { amount_hours, date: self.date, merch },
        }),
      });
      const json = yield response.json();
    }),
    setAmount_Outlets: flow(function* (merch, amount_outlets) {
      self.amount_outlets = Number(amount_outlets);
      const response = yield fetch(`${URL_API}/api/settrip`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: { amount_outlets, date: self.date, merch },
        }),
      });
      const json = yield response.json();
    }),
    setComment: flow(function* (merch, comment) {
      self.comment = comment;

      const response = yield fetch(`${URL_API}/api/settrip`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: { comment, date: self.date, merch } }),
      });
      const json = yield response.json();
    }),
    setCurrent(visit) {
      self.currentvisit = visit.id;
    },
    add(outlet, merch) {
      let uuid = v4();
      self.visits.push({ id: uuid, outlet: outlet.uuid });
      self.addFetch(uuid, outlet.uuid, merch);
    },
    remove(visit) {
      self.currentvisit = null;
      self.removeFetch(visit.id);
      self.visits.remove(visit);
    },
    removeAll() {
      const visits = self.visits.filter((item) => true);
      for (const visit of visits) {
        self.remove(visit);
      }
    },
    addFetch: flow(function* (id, outlet, merch) {
      try {
        const response = yield fetch(`${URL_API}/api/addvisit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: { uuid: id, outlet, merch, date: self.date },
          }),
        });
        yield response.json();
      } catch (error) {
        console.error("Ошибка:", error);
      }
    }),
    removeFetch: flow(function* (uuid) {
      try {
        const response = yield fetch(`${URL_API}/api/removevisit`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: { uuid },
          }),
        });
        yield response.json();
      } catch (error) {
        console.error("Ошибка:", error);
      }
    }),
  }));
export default Route;
